import { Auth } from 'aws-amplify';

// Claves de sessionStorage que se limpian al cerrar la sesion
const CLAVES_SESION = ['username', 'name', 'user', 'menu', 'token', 'node', 'menuId'];

// Limpia los datos de sesion; si se indica una URL, redirige a ella al terminar
export const removeSession = (redirectUrl) => {
  CLAVES_SESION.forEach((clave) => window.sessionStorage.removeItem(clave));
  if (redirectUrl) {
    window.location.href = redirectUrl;
  }
};

// Cierra la sesion de AD (Cognito) y limpia los datos locales aunque signOut falle
export const logoutSessionAD = (redirectUrl) => {
  try {
    // signOut es asíncrono: el catch de abajo solo ve los errores síncronos.
    Auth.signOut().catch((error) => console.log(error));
    removeSession(redirectUrl);
  } catch (error) {
    console.log(error);
    removeSession(redirectUrl);
  }
};
